import { createContext as o } from "react";
const e = o({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
});
export {
  e as IconContext
};
//# sourceMappingURL=index.es673.js.map
